var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "preferred-departments" } },
    [
      _c(
        "div",
        { staticClass: "preferred-departments-container" },
        [
          _vm._l(_vm.getSelecteddepartments(), function (department) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                followCursor: true,\n                placement: 'bottom-end',\n            }",
                  },
                ],
                key: department._id,
                staticClass: "preferred-departments-element",
                attrs: { content: _vm.getDepartmentName(department) },
              },
              [
                _c("div", {
                  staticClass: "circle",
                  style: {
                    backgroundColor: _vm.isDarkMode ? "white" : "black",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        _vm.visibleModal = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.getDepartmentName(department).slice(0, 15) +
                            (_vm.getDepartmentName(department).length >= 15
                              ? "..."
                              : "")
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.readOnly
            ? _c(
                "button",
                {
                  staticClass: "add-dashed-btn",
                  on: {
                    click: function ($event) {
                      _vm.visibleModal = true
                    },
                  },
                },
                [_c("span", { staticClass: "material-icons" }, [_vm._v("add")])]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.visibleModal
        ? _c("FormModal", {
            staticClass: "preferred-departments-form",
            attrs: {
              title: _vm.$t("message.assignPreferredDepartment"),
              subtitle: _vm.$t("message.departmentAssignedToTheVisitor"),
            },
            on: {
              cancel: function ($event) {
                _vm.visibleModal = false
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "pf-main" }, [
                        _c("div", { staticClass: "pr-search" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchText,
                                expression: "searchText",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t(
                                "message.searchForDepartment"
                              ),
                            },
                            domProps: { value: _vm.searchText },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.searchText = $event.target.value
                                },
                                _vm.searchChange,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons mx-2 pr-icon" },
                            [_vm._v(" search ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pr-items pr-item-wrapper" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "pr-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleDepartment("")
                                  },
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "segment-checkbox",
                                  attrs: {
                                    checked: _vm.selectedDepartmentId === "",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "user-data-wrapper" },
                                  [
                                    _c("div", { staticClass: "user-data" }, [
                                      _c("div", { staticClass: "metas" }, [
                                        _c(
                                          "div",
                                          { staticClass: "pr-item-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.noPreferredDepartment"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.filteredDepartments,
                              function (department) {
                                return _c(
                                  "div",
                                  {
                                    staticClass: "pr-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleDepartment(
                                          department._id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("a-checkbox", {
                                      staticClass: "segment-checkbox",
                                      attrs: {
                                        checked:
                                          _vm.selectedDepartmentId ===
                                          department._id,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "user-data-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "user-data" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "metas" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "pr-item-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getDepartmentName(
                                                          department
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c("a-button", { on: { click: _vm.handleCancel } }, [
                            _vm._v(" " + _vm._s(_vm.$t("message.cancel"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "pr-confirm-btn",
                              attrs: {
                                type: "primary",
                                disabled: !_vm.isChanged(),
                              },
                              on: { click: _vm.handleConfirm },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3725141338
            ),
            model: {
              value: _vm.selectedDepartmentId,
              callback: function ($$v) {
                _vm.selectedDepartmentId = $$v
              },
              expression: "selectedDepartmentId",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }